import { IUpdateRoomModal } from '../../../actions/bookingCalendar/roomModal/requestUpdateRoomModal'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IUpdateRoomModal,
): IBookingCalendarStore {
  return {
    ...state,
    roomModal: {
      ...state.roomModal,
      updateForm: {
        ...state.roomModal.updateForm,
        roomId: action.roomId,
      },
    },
  }
}
